import { render, staticRenderFns } from "./Left.vue?vue&type=template&id=3b812591&scoped=true&lang=html"
import script from "./Left.vue?vue&type=script&lang=js"
export * from "./Left.vue?vue&type=script&lang=js"
import style0 from "./Left.vue?vue&type=style&index=0&id=3b812591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b812591",
  null
  
)

export default component.exports